require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-css-flexbox-use-the-flex-shrink-property-to-shrink-items.json") })
        }
      }, "path---responsive-web-design-css-flexbox-use-the-flex-shrink-property-to-shrink-items");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-css-flexbox-use-the-flex-shrink-property-to-shrink-items!./.cache/json/responsive-web-design-css-flexbox-use-the-flex-shrink-property-to-shrink-items.json
// module id = 2664
// module chunks = 231608221292675